import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { focusDefaultTabInInsights } from "utils/insightsAndAlarmsUtils";
import { getInsightsPagePath } from "utils/router.utils";

import InsightCard from "./InsightCard";

import "./index.scss";

const InsightCardsContainer = ({ insights, setFilterAnomaly, filterValue, selectedSystem, systems }) => {
  const filterVal = filterValue?.toLowerCase() ?? "";

  if (selectedSystem && selectedSystem.length > 0 && selectedSystem[0].systemStatus !== "" && selectedSystem[0].connectionStatus !== "") {
    systems = systems.filter(o1 => selectedSystem.some(o2 => o1.systemStatus === o2.systemStatus && o1.connectionStatus === o2.connectionStatus));
    insights = insights.filter(o1 => systems.some(o2 => o1.SystemId === o2.sysId));
  }

  const FilterFields = ["SystemName", "SystemId", "AnomalyType", "tagId", "label"];
  insights = insights.filter(anamoly => FilterFields.some(prop => anamoly[prop]?.toLowerCase().includes(filterVal)));

  const handleLinkClick = () => focusDefaultTabInInsights();

  useEffect(() => {
    setFilterAnomaly(insights.length);
  }, [insights]);

  return (
    <div className="fullWidth list__container">
      {insights &&
        insights.map(item => (
          <Link to={getInsightsPagePath(item.SystemId)} key={`${item.Id}`} onClick={handleLinkClick}>
            <InsightCard value={item} isRecomendataionRequired={false} />
          </Link>
        ))}
    </div>
  );
};

export default InsightCardsContainer;
